module.exports = __webpack_public_path__ + "static/media/A_iko_2_strzalka_dol.d8d03228.svg";